/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    shape, arrayOf, bool, func, string,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';

import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    dialogTitle: {
        fontSize: '1.06em',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    ContinueFlex: {
        color: '#fff',
        backgroundColor: theme.palette.colorSuccess,
        width: '206px',
        diplay: 'inherit',
        alignItems: 'inherit',
        marginLeft: '36px',
    },
    GoBackFlex: {
        color: '#65388b',
        border: '1px solid rgba(101, 56, 139, 0.5)',
        lineHeight: '1.75',
        fontWeight: '500',
        borderRadius: '4px',
        textTransform: 'uppercase',
        width: '206px',
    },
    MuiGridItem: {
        marginLeft: '36px',
        alignItems: 'center',
        justifyContent: 'center',
    },
    holidayBoxBorder: {
        outline: '1px solid darkgray',
        padding: '20px',
        marginBottom: '20px',
    },
    windowContent: {
        fontSize: '14px !important',
        fontWeight: '400',
    },
    flexMessage: {
        fontStyle: 'italic',
        fontSize: '1em',
        textAlign: 'center',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    flexRadio: {
        color: '#65388b',
    },
    flexWraper: {
        padding: '30px',
    },
    radioButtonColor: {
        color: theme.palette.colorPrimary,
        '&$checked': {
            color: theme.palette.colorPrimary,
        },
    },
}));

const FlexModal = ({
    flexData, isOpen, handleFlexClose, flexAddToCart,
}) => {
    const classes = useStyles();
    // the following hook keeps track of which flex date is selected
    const [selectedDate, setDate] = useState(flexData.find((flexDate) => flexDate?.defaultOption === 'Y'));
    const handleDateChange = (e) => {
        // The whole flex date object needs to be stored in state.
        setDate(flexData.filter((flexDay) => flexDay.optionCode === e.target.value)[0]);
    };
    return (
        <Dialog open={isOpen}>
            <div className={classes.flexWraper}>
                <div className={classes.holidayBoxBorder}>
                    <ReactMarkdown
                        className={classes.dialogTitle}
                        escapeHtml={false}
                        source={flexData[0].flexMsg?.find((message) => message.msgType === '7')?.msgText}
                    />
                </div>

                <Grid container direction="column">
                    <Grid item>
                        <FormControl component="fieldset">
                            <RadioGroup name="flexSelect" value={selectedDate.optionCode} onChange={handleDateChange} row>
                                {flexData.map((flexDay) => (
                                    <FormControlLabel

                                        value={flexDay.optionCode}
                                        control={<Radio classes={{ root: classes.radioButtonColor, checked: classes.checked }} />}
                                        label={(
                                            <ReactMarkdown
                                                className={classes.windowContent}
                                                escapeHtml={false}
                                                source={flexDay.flexMsg?.find((message) => message.msgTypeLocation === 'Product')?.msgText}
                                            />
                                        )}
                                        labelPlacement="end"
                                        key={flexDay.optionCode}
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl>
                        <Grid container direction="row">
                            <Grid className={classes.MuiGridItem} item>
                                <Button className={classes.GoBackFlex} variant="outlined" onClick={handleFlexClose}>
                                    GO BACK
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button className={classes.ContinueFlex} variant="contained" onClick={() => { flexAddToCart(selectedDate); }}>
                                    CONTINUE
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </Dialog>
    );
};

FlexModal.propTypes = {
    isOpen: bool.isRequired,
    handleFlexClose: func.isRequired,
    flexAddToCart: func.isRequired,
    flexData: arrayOf(
        shape({
            defaultOption: string.isRequired,
            flexAmount: string.isRequired,
            flexDate: string.isRequired,
            forcedDelDate: string.isRequired,
            optionCode: string.isRequired,
            flexMsg: arrayOf(
                shape({
                    msgText: string.isRequired,
                    msgType: string.isRequired,
                    msgTypeLocation: string.isRequired,
                }).isRequired,
            ).isRequired,
        }).isRequired,
    ).isRequired,
};

export default FlexModal;
